import React from 'react'

const DotMenu = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16px" height="16px">
    <defs />
    <rect className="a" width="16" height="16" fill="none" />
    <g transform="translate(1 6.5)">
      <path
        className="b"
        d="M12,3a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,12,3ZM6.75,3a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,6.75,3ZM1.5,3A1.5,1.5,0,1,1,3,1.5,1.5,1.5,0,0,1,1.5,3Z"
        transform="translate(0.25)"
      />
    </g>
  </svg>
)

export default DotMenu
